import { render, staticRenderFns } from "./UnifiedLoginView.vue?vue&type=template&id=770a6804&scoped=true"
import script from "./UnifiedLoginView.vue?vue&type=script&lang=js"
export * from "./UnifiedLoginView.vue?vue&type=script&lang=js"
import style0 from "./UnifiedLoginView.vue?vue&type=style&index=0&id=770a6804&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770a6804",
  null
  
)

export default component.exports